<script>
/**
 * Substitui algumas utilizações do VMenu
 * Quando dentro de tabela, pode ser necessário adicionar no pai da tabela a classe fixMenuOnTable
 */
import Dropdown from 'primevue/dropdown';
import BaseVolanInputValidate from './BaseVolanInputValidate';
export default {
  name: 'VolanDropdown',
  components: {Dropdown},
  extends: BaseVolanInputValidate,
  inheritAttrs: false,
  props: {
    optionLabel: {
      type: String,
      default: 'text',
    },
    optionValue: {
      type: String,
      default: 'value',
    }
  }
};
</script>

<template>
  <div class="field mt-2 mb-2 pt-1">
    <label v-if="computedLabel || !hideDetails"
           class="block"
           :for="computedId"
    >{{ computedLabel }}</label>
    <Dropdown :id="computedId"
              :value="value"
              v-bind="$attrs"
              class="p-overlay-open"
              :class="{'p-invalid': isValid===false}"
              :disabled="isDisabled"
              :option-label="optionLabel"
              :option-value="optionValue"
              :readonly="isReadonly"
              v-on="$listeners"
              @focus="onInputFocus"
              @blur="onInputBlur"
    >
      <template v-for="(_, name) in $scopedSlots"
                :slot="name"
                slot-scope="slotData"
      >
        <slot :name="name"
              v-bind="slotData"
        />
      </template>
      <slot v-for="(_, name) in $slots"
            :slot="name"
            :name="name"
      />
    </Dropdown>
    <small v-for="(message, index) of internalErrorMessages"
           :key="index"
           class="p-error block"
    >{{ message }}</small>
    <small v-if="!internalErrorMessages.length"
           class="block"
    >{{ hintComputed }}</small>
  </div>
</template>